"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SVBLabels", {
  enumerable: true,
  get: function get() {
    return _SVBLabels.default;
  }
});
var _SVBLabels = _interopRequireDefault(require("./src/SVBLabels"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }